export default function({ state, commit, dispatch }) {
    // Optimization: if all patients have been loaded, further queries are not necessary
    // if (state.loadedAllProviderPatients || state.loadingAllProviderPatients)
    //     return

    if(state.providers.length === 0)
        return
    if(state.loadingAllProviderLinedownPatients)
        return

    commit('startLoadingAllProviderLinedownPatients')


    return Promise.all(
        [
            ...state.providers.map((provider) => dispatch('loadLinedown', { id: provider.provider }))
        ]
    )
    .then((response) => {
        commit('finishLoadingAllProviderLinedownPatients')
    })
    .catch((error) => {
        commit('finishLoadingAllProviderLinedownPatients')
    })

}
